import { render, staticRenderFns } from "./ItemTitle.vue?vue&type=template&id=5b86f2f6&scoped=true&"
import script from "./ItemTitle.vue?vue&type=script&lang=ts&"
export * from "./ItemTitle.vue?vue&type=script&lang=ts&"
import style0 from "./ItemTitle.vue?vue&type=style&index=0&id=5b86f2f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b86f2f6",
  null
  
)

export default component.exports